import n from "./isBrowser.js";

var e = function e() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).pathname;
  }

  return n() && window.location.pathname || "";
},
    t = function t() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).host;
  }

  return n() && window.location.host || "";
},
    o = function o() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).hostname;
  }

  return n() && window.location.hostname || "";
},
    r = function r() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).hash;
  }

  return n() && window.location.hash || "";
},
    i = function i() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).href;
  }

  return n() && window.location.href || "";
},
    f = function f() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).port;
  }

  return n() && window.location.port || "";
},
    u = function u() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).protocol;
  }

  return n() && window.location.protocol || "";
},
    l = function l() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (e && "string" == typeof e && "undefined" != typeof URL) {
    return new URL(e).search;
  }

  return n() && window.location.search || "";
};

export { r as getWindowHash, t as getWindowHost, o as getWindowHostName, i as getWindowHref, e as getWindowPathname, f as getWindowPort, u as getWindowProtocol, l as getWindowSearch };